import Keycloak from "keycloak-js";
import {setAxiosHeaderConfiguration} from "./axiosService";


// TODO change hardcode to env
class KeycloakService {

    initOptions = {
        url: window.__env__?.REACT_APP_KEYCLOAK_URL ?? process.env.REACT_APP_KEYCLOAK_URL,
        realm: window.__env__?.REACT_APP_KEYCLOAK_REALM ?? process.env.REACT_APP_KEYCLOAK_REALM,
        clientId: window.__env__?.REACT_APP_KEYCLOAK_CLIENT_ID ?? process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
        onLoad: 'login-required',
    }

    kc
    initialized = false

    constructor() {
        this.kc = new Keycloak(this.initOptions)
    }

    init() {
        this.initialized = true

        return new Promise((resolve, reject) => {
            this.kc.init({
                onLoad: this.initOptions.onLoad,
                KeycloakResponseType: 'code',
                // pkceMethod: 'S255'
            }).then((auth) => {
                if (!auth) {
                    window.location.reload();
                } else {
                    this.kc.onTokenExpired = () => {
                        console.log('## token expired ##')
                        window.location.reload();
                        //setAxiosHeaderConfiguration(this.kc.token);
                    }
                    //console.log(this.kc.token)
                    setAxiosHeaderConfiguration(this.kc.token);
                    // console.log(this.kc.tokenParsed.aud)
                    // console.log(this.kc.tokenParsed.azp)
                    // console.log("Authenticated");
                    

                    setInterval(() => {

                        this.kc.updateToken(60*5).then((refreshed) => {
                            if (refreshed) {
                                
                                setAxiosHeaderConfiguration(this.kc.token); 
                                console.log('Token refreshed' + refreshed);
                            } else {
                                console.warn('Token not refreshed, valid for '
                                    + Math.round(this.kc.tokenParsed.exp + this.kc.timeSkew - new Date().getTime() / 1000) + ' seconds');
                            }
                        }).catch((error) => {
                            console.log(error);
                        });

                    }, 1*60*1000);

                    resolve(auth)
                }
            }).catch(() => {
                window.location.reload();

                console.log("Authentication Failed");
                reject()
            });
        });
    }

    isInitialized() {
        return this.initialized
    }

    getToken() {
        return this.kc.token
    }

    updateToken() {
        return new Promise((resolve, reject) => {
            this.kc.update(5).then((refreshed) => {
                if (refreshed) {
                    resolve(refreshed);
                } else {
                    console.warn('Token is still valid');
                }
            }).catch(() => {
                console.error('Failed to refresh token');
                reject();
            });
        });
    }

    authenticated() {
        return this.kc.authenticated;
    }

    logout() {
        this.kc.logout();
    }
}

const keycloakService = new KeycloakService();
export default keycloakService;